function initTryItTodayScroll() {
    var desktopButton = $('.try-it-btn-desktop');
    if(desktopButton !== undefined && desktopButton.length > 0) {
        if($(window).width() >= 1160) {
            var buttonPosition = desktopButton.offset().top;
            var doucmentScroll = $(document).scrollTop();
            if(doucmentScroll > buttonPosition) {
                $('.try-it-btn-mobile').addClass('try-it-btn-top');
            } else {
                $('.try-it-btn-mobile').removeClass('try-it-btn-top');
            }
        }
    }
}

$(function () {
    initTryItTodayScroll();
    $(window).scroll(function () {
        initTryItTodayScroll();
    });
});
